import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const Submit = ({ title = 'Enviar', size=12 }) => {
    const { isSending } = useSelector(state => state.progress);
    return(
        <Grid item xs={12} sm={12} md={size}>
            <LoadingButton
                loading={isSending}
                type="submit"
                variant="contained"
                color="success"
                fullWidth
            >
                {title}
            </LoadingButton>
        </Grid>
    )
}

export default Submit;